<template>
  <div id="app" :class="'splittest-v' + $store.state.splittest_version">
    <section class="bg-1 bg-cover">
      <nav class="bg-specialtop">
        <div class="container">
          <div class="row justify-content-center p-3">
            <div class="col-5 col-md-2 p-0 m-0 text-center text-md-left">
              <router-link :to="{ name: 'index' }">
                <img
                  src="@/assets/logo.png"
                  alt="Zonnestroom Collectief"
                  class="mb-2 mb-md-0"
                />
              </router-link>
            </div>
            <div
              class="col-7 col-md-10 p-0 m-0 align-self-center text-md-right"
            >
              <h4 class="telefoon d-block py-0 m-0 px-2 px-md-5 text-right">
                <font-awesome-icon
                  :icon="['far', 'phone-square']"
                  class="mr-2"
                />
                +31 (0)36 – 7410 981
              </h4>
              <img
                src="@/assets/zonnestroom-5sterren-google-hor.png"
                alt="Google Reviews 5 sterren"
                class="d-block d-md-none pl-5"
              />
            </div>
          </div>
        </div>
      </nav>
      <div class="container">
        <div class="row p-2 pt-md-3">
          <div class="col-12 text-center p-2 p-md-3 m-0 headbalk">
            <b>0% BTW!</b> Voor particulieren is de aanschaf per 1 januari 2023
            <u>BTW-vrij</u>
          </div>
        </div>
      </div>
      <div class="container d-none d-md-block">
        <div class="row">
          <div class="col-12 text-right px-3 pb-3">
            <img
              src="@/assets/zonnestroom-5sterren-google.png"
              alt="Google Reviews 5 sterren"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="naast-form">
      <div class="container position-relative">
        <div class="row">
          <div class="cirkel text-center text-white position-absolute">
            <p class="p-0 m-0 text-uppercase">
              <b class="d-block p-0 m-0 cirkel2">UIT EIGEN</b>
              <b class="d-block p-0 m-0 cirkel2">VOORRAAD</b>
              <b class="d-block p-0 m-0 cirkel1">LEVERBAAR</b>
            </p>
          </div>

          <div
            class="col-12 col-md-5 p-3 px-md-0 m-0 pt-md-5 pr-md-5 text-next-form"
          >
            <h1 class="text-secondary font-weight-bold p-0 m-0 mb-md-3">
              A-merk zonnepanelen, collectief goedkoper
            </h1>
            <h3 class="font-weight-bold p-0 m-0 mb-2 mb-md-3">
              Ontdek hoeveel u op uw energierekening kunt besparen
            </h3>
            <p class="font-weight-light">
              Met Zonnestroom Collectief denkt u niet alleen aan uw portemonnee,
              maar ook aan het milieu.
              <b class="font-weight-bold"
                >Doordat wij onze klanten als collectief behandelen kunnen wij
                extra voordelig voor u de beste deal maken!</b
              >
            </p>

            <p class="font-weight-light p-0 m-0">
              Zonnestroom Collectief heeft een ruime voorraad zonnepanelen.
              Daardoor kunnen wij vrijwel altijd binnen 4 tot 6 weken de
              installatie op uw dak verzorgen! Waar wacht u op?
            </p>

            <div class="text-right mt-n1 d-none d-md-block">
              <img src="@/assets/pijl1.png" alt="pijl" class="" />
              <p class="text-next-form-small text-primary pt-2 pl-md-5">
                Vraag zelf geheel vrijblijvend een afspraak aan met onze
                adviseurs! We nemen hierna contact met u op om eventuele vragen
                en de afspraak verder af te stemmen.
              </p>
            </div>
          </div>
          <div id="form" class="col-12 col-md-7 p-2 p-md-0 m-0 special_formup">
            <div class="bg-white rounded shadow p-3 p-md-5">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-n3 mt-md-n5">
      <img src="@/assets/PaarsegolfTop2.png" class="w-100 mt-md-n5" />
    </section>

    <section class="bg-primary pt-3 pb-3 pb-md-5 type">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-white p-0 m-0">
              Welk type zonnepaneel past het beste bij uw woning?
            </h1>
            <h2 class="text-secondary p-0 m-0 mb-md-3">
              We helpen u de juiste match vinden
            </h2>
            <p class="text-white p-0 m-0">
              Wij leveren maatwerk. De juiste zonnepanelen voor ieder dak. Een
              onderdeel van ons advies is het bekijken welk type zonnepanelen
              het beste geschikt is voor uw situatie. Zonnepanelen produceren
              energie in gelijkstroom. Om deze geproduceerde energie om te
              zetten in bruikbare wisselstroom (230V) zijn omvormers nodig. De
              omvormer is het hart van uw systeem en bepaalt uw rendement. Er
              zijn verschillende type omvormers op de markt. Traditionele string
              omvormers en micro omvormers.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section style="z-index: 200">
      <img
        src="@/assets/dak-installatie-zonnepanelen.jpg"
        alt="Dakinstallatie"
        class="w-100"
      />
    </section>

    <section class="bg-geel pt-5 pb-3 py-md-5 px-3">
      <div class="container">
        <div class="row">
          <div class="col-12 p-3 p-md-5 bg-white rounded">
            <h1 class="p-0 m-0">Heeft u nog vragen?</h1>
            <h2 class="text-secondary p-0 m-0 mb-2">
              We beantwoorden hier de meest gestelde vragen
            </h2>
            <h5 class="font-weight-light p-0 m-0">
              Heeft u toch nog andere vragen? Neem gerust contact met ons op!
            </h5>
            <div class="container pt-2 pb-0 px-3 px-md-5 pt-md-5 pb-md-3">
              <div class="row justify-content-center my-2">
                <div
                  class="col-12 rounded border border-primary p-3 p-md-4 text-primary cursor-pointer"
                  @click="isHidden1 = !isHidden1"
                >
                  <h4 class="p-0 m-0">
                    Is mijn dak geschikt voor zonnepanelen?
                  </h4>
                  <p v-if="!isHidden1" class="p-0 m-0">
                    Meer dan 90% is geschikt. Na uw aanvraag controleren wij dit
                    voor u. We houden hier bijvoorbeeld rekening met hoe oud het
                    dak is, welke ligging je dak(vlak) heeft, de locatie in
                    Nederland in verband met wind regio’s en de hellingshoek.
                    Daarna nemen we samen telefonisch uw wensen door om zo het
                    beste zonnedak voor u in te tekenen.
                  </p>
                </div>
              </div>
              <div class="row justify-content-center my-2">
                <div
                  class="col-12 rounded border border-primary p-3 p-md-4 text-primary cursor-pointer"
                  @click="isHidden2 = !isHidden2"
                >
                  <h4 class="p-0 m-0">Welke garanties en services krijg ik?</h4>
                  <p v-if="!isHidden2" class="p-0 m-0">
                    Wij geven 10 jaar installatiegarantie. Hier valt de werking
                    van het gehele systeem onder. Dat beloven we. Gaat er iets
                    stuk binnen de installatiegarantie termijn? Dan vervangen we
                    gratis uw zonnepanelen, omvormer(s), optimizer(s) en delen
                    van het kabeltraject. De productgarantie kan verschillen per
                    merk en type product, zo is die van de zonnepanelen veelal
                    langer dan 10 jaar.
                  </p>
                </div>
              </div>
              <div class="row justify-content-center my-2">
                <div
                  class="col-12 rounded border border-primary p-3 p-md-4 text-primary cursor-pointer"
                  @click="isHidden3 = !isHidden3"
                >
                  <h4 class="p-0 m-0">
                    Hoe wordt de stroom verrekend met mijn energierekening?
                  </h4>
                  <p v-if="!isHidden3" class="p-0 m-0">
                    U ontvangt van ons na akkoord op uw offerte uitleg over hoe
                    u uw systeem kunt aanmelden bij uw netbeheerder (of
                    energieleveren.nl). Dit is een eenvoudig proces. Uw zonnedak
                    is dan bekend bij de regionale netbeheerder, wat wettelijk
                    verplicht is. Hierna wordt deze automatisch aangemeld bij uw
                    energieleverancier en start de verrekening en besparing!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-light py-3 py-md-5 over">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <h1 class="p-0 m-0">Over Zonnestroom Collectief</h1>
            <h2 class="text-secondary p-0 m-0 mb-2">
              Zonnestroom Collectief, gestart als vrienden voor vrienden
            </h2>
            <p>
              Kennis, oprechtheid, service gericht en kwaliteit, dit zijn de
              kernwaarden van Zonnestroom Collectief.
              <a href="https://www.zonnestroomcollectief.nl" target="_blank"
                >Zonnestroom Collectief</a
              >
              is ontstaan uit een samenwerking tussen drie succesvolle
              ondernemers die vinden dat verduurzaming en duurzaamheid voor
              iedereen binnen handbereik moet zijn. Hierin staat duidelijke
              communicatie voorop. Afspraak is afspraak. Wij denken met u mee
              geven u advies op maat. Iedere woning of bedrijfspand vraagt om
              zijn eigen specifieke benadering. Wat heeft u echt nodig aan
              capaciteit? Wat zijn u toekomstplannen op het gebied van
              duurzaamheid? Uit eigen ervaring weten wij hoe belangrijk het is
              om bij uw aanschaf op de juiste wijze begeleid te worden.
            </p>
            <p class="p-0 m-0 font-weight-bold">
              Zonnestroom Collectief kijkt dan ook verder dan de kosten voor het
              plaatsen van zonnepanelen, wij denken met u mee op het gebied van
              uw investering, het rendement en uw toekomstplannen.
            </p>

            <a
              v-smooth-scroll
              href="#form"
              class="btn btn-secondary text-white mt-3 mt-md-4"
            >
              <h5 class="m-0 px-3 py-2 px-md-4 py-md-2">
                Neem vrijblijvend contact op
              </h5>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <img
              src="@/assets/over.jpg"
              alt="Over Zonnestroom Collectief"
              class="w-100 p-0 m-0"
            />
          </div>
        </div>
      </div>
    </section>
    <footer class="py-3 py-md-4">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center text-primary">
            <div>
              <p class="p-0 m-0">
                <span
                  class="cursor-pointer font-weight-bold px-1 px-md-3"
                  @click="popupOpen('privacy')"
                  >Privacybeleid</span
                >
              </p>

              <small>
                <a href="https://www.zonnestroomcollectief.nl" target="_blank"
                  >Zonnestroom Collectief</a
                >
                - Monitorweg 1 - 1322 BJ Almere - +31 (0)36 – 7410 981</small
              >
            </div>
          </div>
        </div>
      </div>
    </footer>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in"
    >
      <section v-if="popupIsopen" class="popup-container">
        <div class="backdrop" @click="popupDismiss()"></div>

        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 py-3 py-md-5">
              <div class="popup bg-white rounded p-3 py-5 p-md-5 p-lg-5">
                <div class="fa" @click="popupDismiss()">
                  <font-awesome-icon size="2x" :icon="['far', 'times']" />
                </div>

                <api-content
                  v-if="popupIsopen"
                  :content-key="'zonnestroom-' + popupIsopen"
                >
                </api-content>

                <button class="btn btn-primary" @click="popupDismiss()">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import AutoClickID from "@/../../shared/autoclickid.js";
import popup from "@/../../shared/popup.js";

export default {
  components: {
    ApiContent: () => import("@/../../shared/components/ApiContent.vue"),
  },
  mixins: [AutoClickID, popup],
  data() {
    return {
      isHidden1: true,
      isHidden2: true,
      isHidden3: true,
      isHidden4: true,
    };
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "styles/includes";
@import "styles/bootstrap";
@import "styles/fonts";
@import "styles/styles";

@import "@/../../shared/scss/_popup";

.recensies p {
  line-height: 1.5;
}

.paneel img {
  display: block;
  height: auto;
  width: 100%;
}

.bg-specialtop {
  background-color: rgba(255, 255, 255, 0.8);
}

.special_formup {
  margin-top: -250px !important;

  @include media-breakpoint-down(md) {
    margin-top: 0 !important;
  }
}

.text-next-form p {
  font-size: 18px;
  line-height: 1.7;
}

.text-next-form-small {
  font-size: 13px !important;
  line-height: 1.2;
}

.type p {
  font-size: 18px;
  line-height: 1.7;
}

.bg-geel {
  background-image: url("@/../assets/backgroundgeel.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  margin-top: -200px;
  padding-top: 200px !important;
  z-index: 300;
  position: relative;

  @include media-breakpoint-down(md) {
    margin-top: -70px;
    background-size: auto 130%;
    padding-top: 50px !important;
    background-position: top center;
  }
}

.telefoon {
  @include media-breakpoint-down(md) {
    font-size: 13px;
  }
}

@include media-breakpoint-down(md) {
  .naast-form h1 {
    font-size: 1.3rem;
  }

  .naast-form h3 {
    font-size: 1.1rem;
  }

  .naast-form p {
    font-size: 0.75rem;
  }

  .type h1 {
    font-size: 1.3rem;
  }

  .type h2 {
    font-size: 1rem;
  }

  .type p {
    font-size: 0.8rem;
  }

  .bg-geel h1 {
    font-size: 1.3rem;
  }

  .bg-geel h2 {
    font-size: 1rem;
  }

  .bg-geel h5 {
    font-size: 0.8rem;
  }

  .bg-geel h4 {
    font-size: 1rem;
  }

  .over h1 {
    font-size: 1.3rem;
  }

  .over h2 {
    font-size: 1rem;
  }

  .over p {
    font-size: 0.8rem;
  }
}

.cirkel {
  background-color: $primary;
  width: 175px;
  height: 175px;
  border-radius: 50%;
  display: table;
  font-size: 1.2rem;
  line-height: 1.2;
  z-index: 800;
  top: -390px;
  right: -50px;
  animation: pulse 4s infinite;

  @include media-breakpoint-down(md) {
    top: -180px;
    right: 30px;
    width: 145px;
    height: 145px;
  }
}

.cirkel3 {
  font-size: 2.1rem;
}

.cirkel p {
  vertical-align: middle;
  display: table-cell;
}

@keyframes pulse {
  0% {
    transform: scale(0.95) rotate(15deg);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1.15) rotate(15deg);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95) rotate(15deg);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.headbalk {
  border: 2px solid #000;
  background-color: #ffe400;
  border-radius: 10px;
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 1;

  @include media-breakpoint-down(md) {
    font-size: 0.8rem;
    line-height: 1.2;
  }

  b {
    font-weight: 800;

    @include media-breakpoint-down(md) {
      display: block;
      text-align: center;
    }
  }
}
</style>
